import React from "react";

const DataTableHeader = ({ pageSize, search, onLimitChange, onSearchChange }) => {
  const sizeOptions = [5, 10, 25, 50];

  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <div className="d-flex align-items-center">
        Show{" "}
        <select
          value={pageSize}
          onChange={(e) => onLimitChange(parseInt(e.target.value))}
          className="form-select form-select-sm ms-2"
          id="limit"
        >
          {sizeOptions.map((size, index) => (
            <option key={index} value={size}>
              {size}
            </option>
          ))}
        </select>
        &nbsp;entries
      </div>
      <div className="d-flex align-items-center">
        <span className="me-2">Search:</span>
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="form-control form-control-sm"
          placeholder="Type to search..."
        />
      </div>
    </div>
  );
};

export default DataTableHeader;
